import { render } from "./onlineTrain.vue?vue&type=template&id=3841a370&scoped=true&ts=true"
import script from "./onlineTrain.vue?vue&type=script&lang=ts"
export * from "./onlineTrain.vue?vue&type=script&lang=ts"

import "./onlineTrain.vue?vue&type=style&index=0&id=3841a370&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3841a370"]])

export default __exports__